export var addDotAtTheEndOfString = function addDotAtTheEndOfString(value) {
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!value) return value;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (value.charAt(value.length - 1) === '.') return value;
  return "".concat(value, ".");
};